"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _protocolVersion, _conferenceService, _sessionService, _interval, _metricsCache, _latestMetrics, _latestMetricsTimestamp, _uxkitVersion;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryService = void 0;
const Service_1 = require("../Service");
const Telemetry_1 = require("../../models/Telemetry");
const moment_1 = __importDefault(require("moment"));
const bowser_1 = __importDefault(require("bowser"));
const TelemetryApi_1 = __importDefault(require("../../api/TelemetryApi"));
const events_1 = require("../../events");
const debug_1 = __importDefault(require("debug"));
/**
 * @ignore
 */
const debug = debug_1.default('vxt:telemetry');
/**
 * @ignore
 */
const browser = bowser_1.default.getParser(window.navigator.userAgent);
/**
 * @ignore
 */
let TelemetryService = class TelemetryService extends Service_1.BaseConferenceService {
    constructor(sdk, conferenceService, sessionService) {
        super(sdk);
        /**
         * Configuration and default values
         */
        this.configuration = {
            webrtc: {
                enabled: true,
                samplingFreqSec: 10,
                batch: 3,
            },
            device: {
                enabled: true,
            },
        };
        _protocolVersion.set(this, '1.1');
        _conferenceService.set(this, void 0);
        _sessionService.set(this, void 0);
        _interval.set(this, void 0);
        _metricsCache.set(this, {});
        _latestMetrics.set(this, void 0);
        _latestMetricsTimestamp.set(this, void 0);
        _uxkitVersion.set(this, '');
        __classPrivateFieldSet(this, _conferenceService, conferenceService);
        __classPrivateFieldSet(this, _sessionService, sessionService);
    }
    set uxkitVersion(version) {
        __classPrivateFieldSet(this, _uxkitVersion, version);
    }
    localStats() {
        return __classPrivateFieldGet(this, _conferenceService).manager.rtc.getRtpStatsForTelemetry();
    }
    onConferenceJoined(e) {
        return __awaiter(this, void 0, void 0, function* () {
            this._conferenceId = e.conferenceId;
            yield this.getConfiguration();
            if (this.configuration.webrtc.enabled) {
                __classPrivateFieldSet(this, _interval, setInterval(this.collect.bind(this), this.configuration.webrtc.samplingFreqSec * 1000));
            }
        });
    }
    onConferenceLeft(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _interval)) {
                clearInterval(__classPrivateFieldGet(this, _interval));
                __classPrivateFieldSet(this, _interval, null);
            }
            try {
                yield this.sendReport(e.stateDump);
            }
            catch (error) {
                console.log('Sending error: ' + error);
            }
            this._conferenceId = null;
            this.flush();
            __classPrivateFieldSet(this, _metricsCache, {});
            __classPrivateFieldSet(this, _latestMetrics, null);
            __classPrivateFieldSet(this, _latestMetricsTimestamp, null);
        });
    }
    collect() {
        this.localStats().then((stats) => {
            const time = moment_1.default().utc().valueOf();
            const result = { metrics: {} };
            this.analyze(stats, time);
            result['version'] = __classPrivateFieldGet(this, _protocolVersion);
            result['conferenceId'] = this._conferenceId;
            result['userId'] = __classPrivateFieldGet(this, _sessionService).participant.id;
            stats.forEach((v, k) => {
                const tmp = new Array();
                result.metrics[k] = tmp;
                v.forEach((s) => {
                    Telemetry_1.searchMap.forEach((v2, k) => {
                        if (v2(s)) {
                            tmp.push(Telemetry_1.filter(s, Telemetry_1.transformMap[k]));
                        }
                    });
                });
            });
            result['timestamp'] = time;
            __classPrivateFieldGet(this, _metricsCache)[time] = result;
            this.flush();
        });
    }
    analyze(metrics, time) {
        if (__classPrivateFieldGet(this, _latestMetrics)) {
            metrics.forEach((metrics, peerId) => {
                const oldMetrics = __classPrivateFieldGet(this, _latestMetrics).get(peerId);
                if (oldMetrics) {
                    metrics
                        .filter((s) => s.type === 'inbound-rtp' || s.type === 'outbound-rtp' || s.type === 'candidate-pair')
                        .forEach((stat) => {
                        const oldStat = oldMetrics.filter((o) => o.id === stat.id);
                        const deltaSeconds = moment_1.default(time).diff(moment_1.default(__classPrivateFieldGet(this, _latestMetricsTimestamp)), 'seconds');
                        if (stat.bytesSent && oldStat[0] && oldStat[0].bytesSent) {
                            stat.bitrateSent = parseFloat((((stat.bytesSent - oldStat[0].bytesSent) / deltaSeconds / 1024) * 8).toFixed(2));
                        }
                        if (stat.bytesReceived && oldStat[0] && oldStat[0].bytesReceived) {
                            stat.bitrateReceived = parseFloat((((stat.bytesReceived - oldStat[0].bytesReceived) / deltaSeconds / 1024) * 8).toFixed(2));
                        }
                    });
                }
            });
        }
        __classPrivateFieldSet(this, _latestMetrics, metrics);
        __classPrivateFieldSet(this, _latestMetricsTimestamp, time);
    }
    flush() {
        if (Object.keys(__classPrivateFieldGet(this, _metricsCache)).length >= this.configuration.webrtc.batch) {
            TelemetryApi_1.default.webrtc.sendBatch({
                conferenceId: this._conferenceId,
                userId: __classPrivateFieldGet(this, _sessionService).participant.id,
                headers: {
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(__classPrivateFieldGet(this, _metricsCache)),
            });
            __classPrivateFieldSet(this, _metricsCache, {});
        }
    }
    getConfiguration() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.configuration = (yield TelemetryApi_1.default.configuration.fetch()).data;
                debug('Configuration: ', this.configuration);
            }
            catch (e) {
                console.error('Failed to fetch Telemetry configuration!', e);
            }
        });
    }
    onSessionOpened(e) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getConfiguration();
            const data = new Telemetry_1.UserMetric();
            data.userId = __classPrivateFieldGet(this, _sessionService).participant.id;
            data.timestamp = moment_1.default().utc().valueOf();
            const metrics = new Telemetry_1.DeviceInformation();
            const infos = browser.getResult();
            const hardware = new Telemetry_1.HardwareInformation();
            hardware.screen = `${window.screen.width}x${window.screen.height}`;
            metrics.hardware = hardware;
            metrics.name = `${infos.browser.name} ${infos.browser.version}`;
            metrics.os = `${infos.os.name} ${infos.os.version} ${infos.os.versionName}`;
            metrics.timeZone = moment_1.default().format('UTCZ');
            metrics.uxkitVersion = __classPrivateFieldGet(this, _uxkitVersion);
            data.metrics = metrics;
            TelemetryApi_1.default.device.send({ userId: data.userId, timestamp: data.timestamp, data: data });
        });
    }
    sendReport(dump) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let stateDump = dump ? dump : yield ((_a = __classPrivateFieldGet(this, _conferenceService).manager.rtc) === null || _a === void 0 ? void 0 : _a.createStateDump());
                if (stateDump) {
                    let timestamp = moment_1.default().utc().valueOf();
                    TelemetryApi_1.default.dvc.sendBatch({
                        conferenceId: this._conferenceId,
                        userId: __classPrivateFieldGet(this, _sessionService).participant.id,
                        timestamp: timestamp,
                        headers: {
                            'Content-Type': 'application/zip',
                        },
                        data: stateDump.content ? stateDump.content : stateDump,
                    });
                }
            }
            catch (e) {
                console.log('Failed to create and send state dump');
            }
        });
    }
};
_protocolVersion = new WeakMap(), _conferenceService = new WeakMap(), _sessionService = new WeakMap(), _interval = new WeakMap(), _metricsCache = new WeakMap(), _latestMetrics = new WeakMap(), _latestMetricsTimestamp = new WeakMap(), _uxkitVersion = new WeakMap();
TelemetryService = __decorate([
    Service_1.Subscribe([events_1.EventType.SessionOpened])
], TelemetryService);
exports.TelemetryService = TelemetryService;
